/**
 * 节点标识符
 */
export enum NodeNameplate {
  /** 舞台 */
  STAGE = 'stage',

  /** 画布 */
  CANVAS = 'canvas',

  /** 画布包装器 */
  CANVAS_WRAP = 'canvas_wrap',

  /** 场景 */
  SCENE = 'scene',

  /** 组件 */
  COMPONENT = 'component',
}
